<template>
  <div class="campsite-description-text">
    <google-translate-button
      v-if="descriptionNeedsTranslation"
      format="text"
      query-selector-value="campsite-description"
    />
    <div data-g-translate="campsite-description">
      <span class="preserve-linebreaks" v-text="description" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteDescriptionText extends Vue {
  @Prop({ required: true })
  description: string

  @Prop({ default: false })
  descriptionNeedsTranslation: boolean
}

export default toNative(CampsiteDescriptionText)
</script>

<style scoped>
.campsite-description-text {
  font-size: var(--body);
  margin: 1em 0 1.4em;
}
</style>
